import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faDownload, faTrash } from '@fortawesome/free-solid-svg-icons';
import { downloadIcon, SVGIcon, trashIcon } from '@progress/kendo-svg-icons';
import { DocumentService } from 'src/app/services/document.service';
import { PdfAndImageService } from 'src/app/services/pdf-image.service';
import { StudentDocument } from '../../interfaces/student-document';

@Component({
    selector: 'app-documents',
    templateUrl: './documents.component.html',
    styleUrls: ['./documents.component.scss'],
    standalone: false
})
export class DocumentsComponent implements OnChanges {
  @Input() documents: StudentDocument[];
  @Input() editMode: boolean;
  @Output() ondeleteDocument: EventEmitter<StudentDocument> =
    new EventEmitter<StudentDocument>();
  @Output() ondownloadDocument: EventEmitter<StudentDocument> =
    new EventEmitter<StudentDocument>();
  @Input() isPhysicalAssessment: boolean = false;
  @Input() hasPermissionDeleteDoc: boolean = true;
  @Input() status: boolean;
  public trashIcon: SVGIcon = trashIcon;
  public downloadIcon: SVGIcon = downloadIcon;

  confirmDeleteOpen: boolean = false;
  private pendingDeleteRef: number | null = null;

  constructor(
    private documentService: DocumentService,
    private pdfAndImageService: PdfAndImageService,
    private cdr: ChangeDetectorRef,
    library: FaIconLibrary
  ) {
    library.addIcons(faTrash, faDownload);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.documents) {
      this.cdr.detectChanges();
    }
  }

  viewDocument(documentRow: StudentDocument): void {
    if (documentRow.isDoHmhMigrated === true) {
      // Open the document link in a new tab
      window.open(documentRow.docLink, '_blank');
    } else {
      // TODO: Specify `response` with a specific type once the API response is known
      this.documentService
        .getDocument(documentRow.documentRef)
        .subscribe((response) => {
          this.pdfAndImageService.view(response, documentRow.documentFormat);
        });
    }
  }

  confirmDelete(documentRow: StudentDocument): void {
    this.pendingDeleteRef = documentRow.documentRef;
    this.confirmDeleteOpen = true;
  }

  confirmDeleteDocument(): void {
    this.confirmDeleteOpen = false;
    if (this.pendingDeleteRef !== null) {
      this.deleteDocument(this.pendingDeleteRef);
      this.pendingDeleteRef = null;
    }
  }

  cancelDeleteDocument(): void {
    this.confirmDeleteOpen = false;
    this.pendingDeleteRef = null;
  }

  downloadDocument(documentRow: StudentDocument): void {
    if (documentRow.isDoHmhMigrated === true) {
      // Open the document link in a new tab
      window.open(documentRow.docLink, '_blank');
    } else {
      // TODO: Specify the correct type for `response` once the API response structure is known.
      this.documentService
        .getDocument(documentRow.documentRef)
        .subscribe((response) => {
          this.pdfAndImageService.download(
            response,
            documentRow.documentFormat,
            documentRow.documentName
          );
        });
    }
  }

  deleteDocument(entryId: number): void {
    this.documentService.deleteDocument(entryId, 'deleted').subscribe(() => {
      const documentToDelete: StudentDocument = this.documents.find(
        (d: StudentDocument) => d.documentRef === entryId
      );
      if (documentToDelete) {
        this.ondeleteDocument.emit(documentToDelete);
      }
    });
  }
}
